module.exports = __webpack_public_path__ + "media/images/pic/zadowolone-dzieci-58af3bc2dabe05ef48026ce0bbc76452.webp";